import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import WhereWeWorkPage from "./pages/WhereWeWorkPage";
import ProgramsPage from "./pages/ProgramsPage";
import GetInvolvedPage from "./pages/GetInvolvedPage";
import MediaPage from "./pages/MediaPage";
import TransparencyPage from "./pages/TransparencyPage";
import ContactPage from "./pages/ContactPage";
import TeamPage from "./pages/TeamPage";
import OverviewPage from "./pages/OverviewPage";
import ImpactPage from "./pages/ImpactPage";
import NewsEventsPage from "./pages/NewsEventsPage";
import TakeActionPage from "./pages/TakeActionPage";
import PartnershipPage from "./pages/PartnershipPage";
import InternshipPage from "./pages/InternshipPage";
import PolicyEngagementPage from "./pages/PolicyEngagementPage";
import AgriculturePage from "./pages/AgriculturePage";
import ClimateActionPage from "./pages/ClimateActionPage";
import EducationPage from "./pages/EducationPage";
import HealthPage from "./pages/HealthPage";
import InternationalCooperationPage from "./pages/InternationalCooperationPage";
import ChinaInternshipPage from "./pages/ChinaInternshipPage";
import EventsPage from "./pages/EventsPage";
import { WestAfricaPage, EastAfricaPage, SouthernAfricaPage, EuropePage, USAPage, AsiaPage } from "./pages/RegionalOfficePage";
import EmergencyAppealPage from "./pages/EmergencyAppealPage";
import ConsortiumPage from "./pages/ConsortiumPage";
import ConferencesPage from "./pages/ConferencesPage";
import NewsletterReportsPage from "./pages/NewsletterReportsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/overview" element={<OverviewPage />} />
            <Route path="/impact" element={<ImpactPage />} />
            <Route path="/news-events" element={<NewsEventsPage />} />
            <Route path="/take-action" element={<TakeActionPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/where-we-work" element={<WhereWeWorkPage />} />
            <Route path="/programs" element={<ProgramsPage />} />
            <Route path="/get-involved" element={<GetInvolvedPage />} />
            <Route path="/partnership" element={<PartnershipPage />} />
            <Route path="/internship" element={<InternshipPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/media" element={<MediaPage />} />
            <Route path="/transparency" element={<TransparencyPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/policy-engagement" element={<PolicyEngagementPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/programs/agriculture" element={<AgriculturePage />} />
            <Route path="/programs/climate-action" element={<ClimateActionPage />} />
            <Route path="/programs/education" element={<EducationPage />} />
            <Route path="/programs/health" element={<HealthPage />} />
            <Route path="/programs/international-cooperation" element={<InternationalCooperationPage />} />
            <Route path="/internship/china-2026" element={<ChinaInternshipPage />} />
            {/* Regional Offices */}
            <Route path="/opad-west-africa" element={<WestAfricaPage />} />
            <Route path="/opad-east-africa" element={<EastAfricaPage />} />
            <Route path="/opad-southern-africa" element={<SouthernAfricaPage />} />
            <Route path="/opad-europe" element={<EuropePage />} />
            <Route path="/opad-usa" element={<USAPage />} />
            <Route path="/opad-asia" element={<AsiaPage />} />
            {/* Emergency & Consortium */}
            <Route path="/emergency-appeal" element={<EmergencyAppealPage />} />
            <Route path="/consortium" element={<ConsortiumPage />} />
            <Route path="/conferences" element={<ConferencesPage />} />
            <Route path="/newsletter-reports" element={<NewsletterReportsPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
